import { createContext, useContext } from 'react';
import { observer } from 'mobx-react-lite';

import { CombinedKeyMap } from 'app/libs/combined-key-map/combined-key-map';

type CombinedKeyMapFields = {
  trainTypeId: number;
  zoneId: number;
  tariffTypeId: number;
};

type Context = {
  setChangeCellRecord: (ids: CombinedKeyMapFields) => void;
  getCellStatus: (ids: CombinedKeyMapFields) => boolean;
  getSize: () => number;
  clear: () => void;
};

export const createChangeCellState = () => {
  const dataMap = new CombinedKeyMap<CombinedKeyMapFields, boolean>({
    keyBuilder: ['tariffTypeId', 'trainTypeId', 'zoneId'],
  });

  const setChangeCellRecord = (ids: CombinedKeyMapFields) => {
    dataMap.setRecord(ids, true);
  };

  const getCellStatus = (ids: CombinedKeyMapFields) => {
    const result = dataMap.getRecord(ids);
    return !!result;
  };

  const getSize = () => dataMap.size;

  const clear = () => dataMap.clear();

  return { setChangeCellRecord, getCellStatus, getSize, clear };
};

const context = createContext(null as unknown as Context);

type ChangedCellsProviderProps = {
  children: React.ReactNode;
  state: Context;
};
export const ChangedCellsProvider = observer(
  ({ children, state }: ChangedCellsProviderProps) => {
    return <context.Provider value={state}>{children}</context.Provider>;
  },
);

export const useChangeCellState = () => {
  const state = useContext(context);

  if (!state) {
    throw new Error(
      'useChangeCellState must be used within a ChangedCellsProvider',
    );
  }

  return state;
};
